import React from 'react';

import { Box, Link, Text } from '@opendoor/bricks-next';
import { IconChevronRight } from '@tabler/icons-react';
import { motion } from 'framer-motion';

import type { MenuLink } from '../../types';
import { ctaVariant } from '../menuAnimations';

interface MenuCTAProps {
  ctaLink?: MenuLink;
  ctaTitle?: string;
  animate: 'visible' | 'hidden';
}

export const MenuCTA: React.FC<MenuCTAProps> = ({ ctaLink, ctaTitle, animate }) => {
  if (!ctaLink?.name || !ctaLink?.href) return null;

  return (
    <motion.div
      variants={ctaVariant}
      animate={animate}
      style={{
        paddingTop: 16,
        paddingBottom: 16,
        paddingLeft: 24,
        paddingRight: 24,
        width: '100%',
      }}
    >
      <Link
        href={ctaLink.href}
        aria-label={ctaLink.name}
        analyticsName={`cosmos-landing-page-v2-menu-cta-link-${ctaLink.name}`}
        backgroundColor="$backgroundSecondary"
        borderRadius="$8x"
        display="flex"
        flexDirection="row"
        alignItems="center"
        justifyContent="space-between"
        paddingTop="$8x"
        paddingBottom="$8x"
        paddingLeft="$10x"
        paddingRight="$10x"
        textDecorationLine="none"
      >
        <Box>
          {ctaTitle && (
            <Text tag="span" display="block" typography="$labelSmall" color="$contentPrimary">
              {ctaTitle}
            </Text>
          )}
          <Text tag="span" display="block" typography="$bodySmall" color="$contentSecondary">
            {ctaLink.name}
          </Text>
        </Box>
        <Text tag="span" typography="$bodySmall" color="$contentPrimary">
          <IconChevronRight size={24} />
        </Text>
      </Link>
    </motion.div>
  );
};
